import { Paragraph } from '@vimeo/iris/typography';

export default function Notifications() {
  return (
    <div>
      <Paragraph size="2">
        <em>Notifications</em> are system messages or alerts.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
